import styled from 'styled-components';
import Constants from '../../submodules/logictry_config/constants';
//
// Tailwind CSS v3 default `theme.boxShadow` — use in styled-components for parity with `shadow-*` utilities
//
export const twShadowSm = '0 1px 2px 0 rgb(0 0 0 / 0.05)';
export const twShadow = '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)';
export const twShadowMd = '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)';
export const twShadowLg = '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)';
export const twShadowXl = '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)';
export const twShadow2xl = '0 25px 50px -12px rgb(0 0 0 / 0.25)';

/** Modal / dialog surfaces: hairline ring (`Constants.HairlineBorderRgba`) + `shadow-xl`. */
export const twModalSurfaceShadow = `0 0 0 1px ${Constants.HairlineBorderRgba}, ${twShadowXl}`;

//
// Core layout components
//
export const Card = styled.div`
  background: ${Constants.SurfaceColor};
  width: 460px;
  max-width: 100%;
  padding: 2rem;
  border-radius: 1rem;
  box-sizing: border-box;
`;

export const LogoHeader = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;

  img {
    height: 36px;
  }
`;

export const Title = styled.h2`
  font-size: ${Constants.LargeFontSize};
  ${Constants.MediaMobile} {
    font-size: ${Constants.SemiLargeFontSize};
  }
  font-weight: 600;
  text-align: center;
  color: ${Constants.DarkTextColor};
  margin-bottom: 0.5rem;
`;

/** Modal / sheet headers — matches LogicBase home section titles (left-aligned, bold). */
export const ModalSheetTitle = styled.h2`
  margin: 0 0 1rem;
  font-size: 1.2rem;
  font-weight: 700;
  letter-spacing: -0.025em;
  text-align: left;
  color: ${Constants.DarkTextColor};
  ${Constants.MediaMobile} {
    font-size: 1.05rem;
  }
`;

export const Subtitle = styled.p`
  text-align: center;
  color: #555;
  margin: 0 0 1rem 0;
`;

// Section title
export const SectionTitle = styled.h3`
  font-size: ${Constants.SemiSmallFontSize};
  font-weight: 500;
  margin: 1.5rem 0 1rem;
  color: ${Constants.DarkTextColor};
  text-align: center;
`;

//
// Form layout
//
export const Form = styled.div`
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
`;

export const InputBlock = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  position: relative;
`;

export const InlineFieldRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  > :last-child {
    flex-shrink: 0;
  }
`;

export const Label = styled.label`
  position: absolute;
  top: -8px;
  left: 8px;
  background: ${Constants.SurfaceColor};
  padding: 0 6px;
  font-size: ${Constants.VerySmallFontSize};
  font-weight: 500;
  color: ${Constants.MediumTextGray};
`;

//
// Input
//
export const InputWrapper = styled.div`
  margin-bottom: 20px;
`;
export const Input = styled.input`
  width: 100%;
  padding: 0.7rem 0.8rem;
  border-radius: 0.5rem;
  border: ${Constants.LightBorder};
  outline: none;
  transition: border-color 0.12s ease;
  color: ${Constants.DarkTextColor};
  background: ${Constants.SurfaceColor};

  &:focus {
    border-color: ${Constants.PrimaryColor};
    box-shadow: 0 0 0 3px color-mix(in srgb, ${Constants.PrimaryColor} 22%, transparent);
  }
  &::placeholder {
    font-size: ${Constants.SmallFontSize};
    opacity: 0.6;
  }
`;
export const TextArea = styled.textarea`
  width: 100%;
  padding: 0.7rem 0.8rem;
  border-radius: 0.5rem;
  border: ${Constants.LightBorder};
  outline: none;
  transition: border-color 0.12s ease;
  color: ${Constants.DarkTextColor};
  font-family: inherit;
  resize: vertical;
  min-height: 90px;

  &:focus {
    border-color: ${Constants.PrimaryColor};
    box-shadow: 0 0 0 3px color-mix(in srgb, ${Constants.PrimaryColor} 22%, transparent);
  }

  &::placeholder {
    font-size: ${Constants.SmallFontSize};
    opacity: 0.6;
  }
`;

//
// Select
//
export const SelectField = styled.select`
  width: 100%;
  padding: 0.7rem 2.2rem 0.7rem 0.8rem;
  border-radius: 0.5rem;
  border: ${Constants.LightBorder};
  background-color: ${Constants.SurfaceColor};
  outline: none;
  transition: border-color 0.12s ease;
  cursor: pointer;
  color: ${Constants.DarkTextColor};

  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;

  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='%23222' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 0.8rem center;
  background-size: 14px;

  &:focus {
    border-color: ${Constants.PrimaryColor};
    box-shadow: 0 0 0 3px color-mix(in srgb, ${Constants.PrimaryColor} 22%, transparent);
  }
`;

//
// Buttons
//
export const PrimaryButton = styled.button`
  width: 100%;
  padding: 0.75rem;
  background: ${Constants.DarkTextColor};
  color: ${Constants.isDarkMode ? '#000' : '#fff'};
  border: none;
  border-radius: 0.5rem;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: ${Constants.isDarkMode ? '#e8e8e8' : '#000'};
  }
`;

export const SecondaryTextButton = styled.button`
  margin-top: 1rem;
  font-size: ${Constants.SemiSmallFontSize};
  background: none;
  border: none;
  text-decoration: underline;
  color: ${Constants.MediumTextGray};
  cursor: pointer;
  text-align: center;

  &:hover {
    color: ${Constants.LightTextGray};
  }
`;

export const SmallHint = styled.p`
  margin-top: 2rem;
  color: ${Constants.MediumTextGray};
  font-size: ${Constants.SemiSmallFontSize};
  text-align: center;
`;

export const WarningText = styled.div`
  margin-top: 0.5rem;
  min-height: 1.1em;
  color: #b00020;
  text-align: center;
`;

export const DialogActions = styled.div`
  margin-top: 2rem;
  display: flex;
  justify-content: space-evenly;
  gap: 1rem;
`;

export const ButtonBase = styled.button`
  padding: 0.75rem 1.1rem;
  border-radius: 999px;
  border: ${Constants.LightBorder};
  cursor: pointer;
  font-weight: 550;
  width: 100%;
`;

export const ConfirmButton = styled(ButtonBase)`
  background: ${Constants.DarkTextColor};
  color: ${Constants.isDarkMode ? '#000' : '#fff'};

  &:hover {
    background: ${Constants.isDarkMode ? '#e8e8e8' : '#000'};
  }
`;

export const CancelButton = styled(ButtonBase)`
  background: ${Constants.SurfaceColor};
  color: ${Constants.LightTextGray};
  border-color: ${Constants.LightBorderColor};

  &:hover {
    background: ${Constants.SurfaceHover};
  }
`;

export const SettingsButton = styled(ButtonBase)`
  color: ${Constants.LightTextGray};
  border-color: ${Constants.LightBorderColor};

  &:hover {
    background: ${Constants.LightBackground};
  }
`;

//
// Checkboxes
//
/** White check on brand fill — avoids OS `accent-color` (e.g. green + black tick). */
const checkboxCheckDataUri = `data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 12 12%22%3E%3Cpath d=%22M2 6l3 3 5-5%22 stroke=%22white%22 stroke-width=%222%22 fill=%22none%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22/%3E%3C/svg%3E`;

export const CheckboxRow = styled.label`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: ${Constants.SemiSmallFontSize};
  color: ${Constants.LightTextGray};
  cursor: pointer;

  input {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    margin: 0;
    cursor: pointer;
    appearance: none;
    -webkit-appearance: none;
    border: 1.5px solid ${Constants.LightGray};
    border-radius: 4px;
    background: ${Constants.SurfaceColor};
    vertical-align: middle;
    transition: background 0.12s ease, border-color 0.12s ease;
  }

  input:checked {
    background-color: ${Constants.PrimaryColor};
    border-color: ${Constants.PrimaryColor};
    background-image: url('${checkboxCheckDataUri}');
    background-size: 10px 10px;
    background-position: center;
    background-repeat: no-repeat;
  }

  input:focus-visible {
    outline: 2px solid ${Constants.PrimaryColor};
    outline-offset: 2px;
  }

  input:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;

export const Details = styled.details`
  width: 100%;

  &[open] > :not(summary) {
    margin-top: 0.75rem;
  }
`;

export const Summary = styled.summary`
  list-style: none;
  cursor: pointer;

  /* Kill Safari native marker */
  &::-webkit-details-marker {
    display: none;
  }

  display: flex;
  align-items: center;
  gap: 0.5rem;

  font-size: ${Constants.SemiSmallFontSize};
  font-weight: 500;
  color: ${Constants.DarkTextColor};

  padding: 0.5rem 0.25rem;
  border-radius: 0.5rem;

  user-select: none;
  -webkit-tap-highlight-color: transparent;

  appearance: none;
  -webkit-appearance: none;

  /* Caret icon */
  background-repeat: no-repeat;
  background-position: left 0rem center;
  background-size: 14px;

  transition: background-image 0.12s ease;
`;
